import React, { Component } from 'react';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';

const monthMap = [
    { code: "04", name: "April" },
    { code: "05", name: "May" },
    { code: "06", name: "June" },
    { code: "07", name: "July" },
    { code: "08", name: "August" },
    { code: "09", name: "September" },
    { code: "10", name: "October" },
    { code: "11", name: "November" },
    { code: "12", name: "December" },
    { code: "01", name: "January" },
    { code: "02", name: "February" },
    { code: "03", name: "March" }
];

class PartyWiseMonthlySales extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            partyDropdownList: [],
            partyWiseMonthlySalesList: [],
            tableStatus: "",
            filterDetails: {
                partyId: "",
                search: "amount",
            },
            searchList: [
                { search: "Amount", value: "amount" },
                { search: "Quantity", value: "quantity" },
                { search: "Free", value: "free" },
                { search: "Quantity + Free", value: "quantity&free" },
            ],
        };
    }

    componentDidMount() {
        this.getAllPartyDropdown()
    }

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                }));
                this.setState({ partyDropdownList: dropdownItems });
            } else {
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details });
    };

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.filterDetails;
        details[drpIdentity] = selected.value;
        this.setState({ filterDetails: details }, () => {
            this.getAllPartyWiseMonthlySalesByPartyId(this.state.filterDetails.partyId)
        });
    };

    getAllPartyWiseMonthlySalesByPartyId = (id) => {
        this.setState({ tableStatus: "Loading..." })
        this.despatchServices.getAllPartyWiseMonthlySalesByPartyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ partyWiseMonthlySalesList: res })
            } else {
                this.setState({ tableStatus: "" })
                this.SwalServices.Error(response.Message);
            }
        });
    }

    render() {
        return (
            <div className='partyWiseMonthlySales-page'>

                <div className="item-grp flex gap-2.5 mb-3.5 w-[60%]">
                    <div className="search-grp w-[60%]">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            options={this.state.partyDropdownList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                this.setFilterParameters(selected, "partyId")
                            }
                            allowSelectAll={false}
                            value={this.state.partyDropdownList.filter(
                                (party) =>
                                    party.value === this.state.filterDetails.partyId
                            )}
                        />
                    </div>

                    <div className="search-grp w-[40%]">
                        <label>Search</label>
                        <select
                            name="search"
                            className="w-full"
                            value={this.state.filterDetails.search && this.state.filterDetails.search !== 'Select' && this.state.searchList.find(
                                (party) => party.value === this.state.filterDetails.search
                            ).value}
                            onChange={(event) =>
                                this.handleDropDownChange(event, "search")
                            }
                        >
                            {this.state.searchList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.search}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div class="item-listing">
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 125px)" }} >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[15%]'>Item Name</td>
                                        {monthMap.map((month) => (
                                            <td key={month.code} className="w-[6%]">{month.name}</td>
                                        ))}
                                        <td className='w-[12%] !text-center'>Total</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.partyWiseMonthlySalesList.length > 0 ? (
                                        this.state.partyWiseMonthlySalesList.map((details, key) => {
                                            let totalSold = 0;
                                            let totalFree = 0;
                                            let totalAmount = 0;
                                            return (
                                                <tr key={key} >
                                                    <td>{details.itemName}</td>
                                                    {this.state.filterDetails.search === 'quantity' ?
                                                        <>
                                                            {monthMap.map((month) => {
                                                                let sold = details.salesData[month.code]?.sold || 0;
                                                                totalSold += sold;
                                                                return (
                                                                    <td key={month.code}>
                                                                        {sold > 0 ? sold : "-"}
                                                                    </td>
                                                                );
                                                            })}
                                                            <td className='!text-center'>{totalSold}</td>
                                                        </>
                                                        : this.state.filterDetails.search === 'free' ?
                                                            <>
                                                                {monthMap.map((month) => {
                                                                    let free = details.salesData[month.code]?.free || 0;
                                                                    totalFree += free;
                                                                    return (
                                                                        <td key={month.code}>
                                                                            {free > 0 ? free : "-"}
                                                                        </td>
                                                                    );
                                                                })}
                                                                <td className='!text-center'>{totalFree}</td>
                                                            </>
                                                            : this.state.filterDetails.search === 'amount' ?
                                                                <>
                                                                    {monthMap.map((month) => {
                                                                        let amount = details.salesData[month.code]?.amount || 0;
                                                                        totalAmount += amount;
                                                                        return (
                                                                            <td key={month.code}>
                                                                                {amount > 0 ? amount : "-"}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                    <td className='!text-center'>{totalAmount}</td>
                                                                </>
                                                                : this.state.filterDetails.search === 'quantity&free' ?
                                                                    <>
                                                                        {monthMap.map((month) => {
                                                                            let free = details.salesData[month.code]?.free || 0;
                                                                            let sold = details.salesData[month.code]?.sold || 0;
                                                                            totalFree += free;
                                                                            totalSold += sold
                                                                            return (
                                                                                <td key={month.code}>
                                                                                    {sold > 0 ? sold + free : "-"}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                        <td className='!text-center'>{totalFree + totalSold}</td>
                                                                    </>
                                                                    : null}
                                                </tr>
                                            );
                                        })
                                    ) : this.state.partyWiseMonthlySalesList &&
                                        this.state.partyWiseMonthlySalesList.length === 0
                                        && this.state.tableStatus !== "" ? (
                                        <tr>
                                            <td colSpan={14} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.tableStatus}
                                            </td>
                                        </tr>
                                    ) : this.state.partyWiseMonthlySalesList &&
                                        this.state.partyWiseMonthlySalesList.length === 0
                                        && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default PartyWiseMonthlySales;